import { graphql } from "react-relay";

export const ProcessOrgFileMutation = graphql`
  mutation ProcessOrgFileMutation($input: String!) {
    processOrgFile(input: $input)
  }
`;
